<script>
import { roleMethods, userMethods } from '@state/helpers'
import _ from 'lodash'

export default {
  data() {
    return {
      loadingError: null,
      loading: true,
      pagination: {
        rowsPerPage: -1,
      },
      items: [],
      totalData: 0,
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Users', value: 'name', sortable: false },
        { text: 'Actions', value: 'name', sortable: false },
      ],
      dialog: false,
      formError: null,
      isWorking: false,
      editedIndex: -1,
      editedItem: {
        name: null,
      },
      defaultItem: {
        name: null,
      },

      userDialog: false,
      userHeaders: [
        { text: 'In Role', value: 'username', sortable: false },
        { text: 'First Name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' },
        { text: 'Username', value: 'username' },
      ],
      userPagination: {
        rowsPerPage: 25,
      },
      userItems: [],
      userTotalData: 0,
      userLoading: false,
      userSearch: '',
      userLoadingError: null,
      selectedRole: null,
      userAddError: null,
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add Role' : `Edit Role`
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    userPagination: {
      handler() {
        this.getUserDataFromApi()
      },
      deep: true,
    },
  },
  created() {
    this.getDataFromApi = _.debounce(this.getDataFromApi, 500)
    this.getUserDataFromApi = _.debounce(this.getUserDataFromApi, 500)
  },
  methods: {
    ...roleMethods,
    ...userMethods,
    getDataFromApi() {
      this.loading = true
      var vm = this
      return this.getRoles({
        force: true,
        queryTerms: { ...this.pagination },
      })
        .then(data => {
          vm.loading = false

          vm.totalData = data.totalCount
          vm.items = data.results
        })
        .catch(error => {
          vm.loading = false
          vm.loadingError = error
        })
    },
    getUserDataFromApi() {
      this.userLoading = true
      var vm = this
      return this.getUsers({
        queryTerms: { ...this.pagination, filter: this.search },
      })
        .then(data => {
          vm.userLoading = false

          vm.userTotalData = data.totalCount
          vm.userItems = data.results
        })
        .catch(error => {
          vm.userLoading = false
          vm.userLoadingError = error
        })
    },
    save() {
      this.isWorking = true
      this.formError = null

      if (this.editedIndex !== -1) {
        // Update user
        this.updateRole({ role: this.editedItem })
          .then(response => {
            this.isWorking = false
            var role = response.data
            var matches = this.items.filter(x => x.id === role.id)
            if (matches.length) {
              var current = matches[0]
              var indexToReplace = this.items.indexOf(current)
              this.items[indexToReplace] = role
            }
            this.dialog = false
          })
          .catch(error => {
            this.isWorking = false
            this.formError = error.response.data
          })
      } else {
        // Add new
        this.addRole({ role: this.editedItem })
          .then(response => {
            this.isWorking = false
            var role = response.data
            this.items.unshift(role)
            this.totalData += 1
            this.dialog = false
          })
          .catch(error => {
            this.isWorking = false
            this.formError = error.response.data
          })
      }
    },
    confirmDelete(role) {
      this.$swal({
        title: 'Confirm',
        text: 'Are you sure you want to delete this role?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
      }).then(result => {
        if (result.value) {
          this.delete(role)
        }
      })
    },
    delete(role) {
      this.deleteRole({ role })
        .then(response => {
          var index = this.items.indexOf(role)
          if (index !== -1) {
            this.items.splice(index, 1)
          }
        })
        .catch(error => {
          this.$swal('Error', error.response.data, 'error')
        })
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    openUserDialog(item) {
      this.selectedRole = item
      this.userDialog = true
    },
    userIsSelected(user) {
      if (!this.selectedRole) {
        return false
      }

      var matching = this.selectedRole.userRoles.filter(
        u => u.userId === user.id
      )
      return matching.length > 0
    },
    userCheckChange(checked, user) {
      if (checked) {
        this.addUsersToRole({ roleId: this.selectedRole.id, users: [user.id] })
          .then(response => {
            this.selectedRole.userRoles.push({
              userId: user.id,
              roleId: this.selectedRole.id,
            })
          })
          .catch(error => {
            this.userAddError = error
          })
      } else {
        this.removeUsersFromRole({
          roleId: this.selectedRole.id,
          users: [user.id],
        })
          .then(response => {
            var toRemove = this.selectedRole.userRoles.filter(
              r => r.userId === user.id && r.roleId === this.selectedRole.id
            )
            if (toRemove.length > 0) {
              var indexToRemove = this.selectedRole.userRoles.indexOf(toRemove)
              this.selectedRole.userRoles.splice(indexToRemove, 1)
            }
          })
          .catch(error => {
            this.userAddError = error
          })
      }
    },
  },
}
</script>

<template>
  <v-card>
    <!-- Table header -->
    <v-toolbar flat color="transparent">
      <v-toolbar-title>Roles</v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- Add role dialog -->
      <v-dialog v-model="dialog" max-width="500px">
        <v-btn slot="activator" color="cyan" dark depressed class="mb-2">{{
          formTitle
        }}</v-btn>
        <v-card class="px-3 py-2">
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-text-field
              v-model="editedItem.name"
              label="Role Name"
              color="cyan"
            ></v-text-field>
            <v-alert :value="formError" type="error">{{ formError }}</v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="cyan" dark depressed outline @click="close"
              >Cancel</v-btn
            >
            <v-btn color="cyan" dark depressed @click="save">
              <BaseIcon v-if="isWorking" name="sync" spin />
              <span v-else>Add Role</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="userDialog" max-width="700px">
        <v-card>
          <v-card-title>
            <span class="headline">Add/Remove Users</span>
          </v-card-title>

          <v-card-text>
            <v-data-table
              :headers="userHeaders"
              :items="userItems"
              :pagination.sync="userPagination"
              :total-items="userTotalData"
              :loading="userLoading"
              :search="userSearch"
              class="elevation-1"
            >
              <v-progress-linear
                slot="progress"
                color="blue"
                indeterminate
              ></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    :input-value="userIsSelected(props.item)"
                    primary
                    hide-details
                    color="cyan"
                    @change="checked => userCheckChange(checked, props.item)"
                  ></v-checkbox>
                </td>
                <td>{{ props.item.firstName }}</td>
                <td>{{ props.item.lastName }}</td>
                <td>{{ props.item.username }}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <!-- Table -->
    <v-data-table
      :headers="headers"
      :items="items"
      :pagination.sync="pagination"
      :total-items="totalData"
      :loading="loading"
      class="elevation-1"
    >
      <v-progress-linear
        slot="progress"
        color="blue"
        indeterminate
      ></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td>{{ props.item.name }}</td>
        <td :class="$style.clickable" @click="openUserDialog(props.item)">
          {{ props.item.userRoles.length }}
          <v-icon small class="mr-2">edit users</v-icon>
        </td>
        <td>
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small class="mr-2" @click="confirmDelete(props.item)"
            >delete</v-icon
          >
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';

.clickable {
  cursor: pointer;
}
</style>
